import {
  GeoJSON
} from "react-leaflet";

/**
 * インフラツーリズムマップ: サイクリングロードのgeojson用component
 * @param menu
 * @param option
 * @param data
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({data, option}) => {

    // 各フィーチャーにポップアップをバインド
    const onEachFeature = (feature, layer) => {
        layer.bindPopup(option.label, {
            autoPan: true,
            autoPanPaddingTopLeft: [300, 50],
            autoPanPaddingBottomRight: [50, 50]
        });
    };

    return (
        <>
            <GeoJSON
                data={data}
                style={{
                    color: option.color,
                    opacity: 1.0,
                    weight: 7.5,
                    fillColor: option.color,
                    fillOpacity: 1.0,
                }}
                onEachFeature={onEachFeature}
            />
        </>
    )
}

export default Component;
